export default __webpack_public_path__ + "static/media/logo_th.7f2a7340.svg";